import {getCanvasAppParentOrigin} from '@packages/utilities/canvas-origin';

/**
 * Sends message to Designer App that user has clicked on the link element in the Canvas that
 * has provided href.
 *
 * Eng note (from @olena): Eventually we want be able to combine this with elementClickedOnCanvas
 */
export const linkClickedOnCanvas = ({href}: {href: string}) => {
  const message = {method: 'linkClickedOnCanvas', href};
  const designerAppOrigin = getCanvasAppParentOrigin(window);

  if (designerAppOrigin) {
    window.parent.postMessage(message, designerAppOrigin);
  }
};
